import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

/**
 * WarningIcon
 * Ikona upozornenia pre zobrazovanie chybových alebo varovných hlásení.
 */
const WarningIcon = ({ className = 'inline-block align-middle', ...props }) => (
  <FiAlertTriangle className={className} {...props} />
);

export default WarningIcon;

